var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyDescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 555,
    viewBox: "0 0 415 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.44 515H106.43C47.75 515 0 467.26 0 408.57V141.43C0 82.75 47.74 35 106.43 35H299.44C358.12 35 405.87 82.74 405.87 141.43V408.58C405.87 467.26 358.13 515.01 299.44 515.01V515Z",
    fill: "#D5CDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.58 496.79H112.54C59.84 496.79 16.96 453.91 16.96 401.21V147.53C16.96 94.8302 59.84 51.9502 112.54 51.9502H297.58C350.28 51.9502 393.16 94.8302 393.16 147.53V401.21C393.16 453.91 350.28 496.79 297.58 496.79Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.66 409.18H115.27C87.55 409.18 65 386.63 65 358.91V187.27C65 159.55 87.55 137 115.27 137H296.66C324.38 137 346.93 159.55 346.93 187.27V358.91C346.93 386.63 324.38 409.18 296.66 409.18Z",
    fill: "#D5CDC6",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.501 272.822L157.214 247.562L174.675 230.082L199.962 255.342C203.693 259.069 207.308 261.438 210.807 262.449C214.352 263.506 217.736 263.481 220.958 262.375C224.272 261.268 227.309 259.333 230.07 256.569C232.922 253.714 235.015 250.513 236.349 246.968C237.774 243.422 238.094 239.739 237.309 235.919C236.571 232.144 234.336 228.393 230.605 224.666L213.471 207.55L130.444 290.666L107.92 268.166L208.409 167.571L248.067 207.187C256.081 215.193 261.495 223.499 264.307 232.106C267.166 240.76 267.585 249.138 265.564 257.241C263.634 265.344 259.426 272.643 252.938 279.138C246.451 285.632 239.271 289.733 231.4 291.441C223.575 293.194 215.45 292.531 207.023 289.451C198.689 286.371 190.515 280.828 182.501 272.822Z",
    fill: "#D80000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.171 292.441L148.549 309.619L198.651 361.017L216.273 343.839L166.171 292.441ZM292.902 254.004L191.085 353.255L213.307 376.052L315.124 276.801L292.902 254.004Z",
    fill: "black",
    fillOpacity: 0.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.1213,
    y: 276,
    width: 185.09,
    height: 185.09,
    transform: "rotate(-45 77.1213 276)",
    stroke: "#5C5C5C",
    strokeOpacity: 0.9,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDescription);
export default __webpack_public_path__ + "static/media/company_description.26e20008f4553699f927cee75a6d7ef9.svg";
export { ForwardRef as ReactComponent };